<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="col-xl-12">
      <div class="row">
        <div class="col-lg-2">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-1300">
                <div>
                  <p class="text-muted mb-2">Demandes d'investissement</p>
                  <h5 class="mb-0" v-if="!LoadingStatistiques">{{ listStatistique.totalRequest }}</h5>
                  <b-spinner v-else variant="success" label="Spinning" className="text-center"></b-spinner>
                </div>
                <div class="avatar-sm ms-auto mt-1">
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                    <span class="avatar-icon">
                      <i class="mdi mdi-file-multiple-outline font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-1300">
                <div class="me-3">
                  <p class="text-muted mb-2">Mes propositions</p>
                  <h5 class="mb-0" v-if="!LoadingStatistiques">{{ listStatistique.total }}</h5>
                  <b-spinner v-else variant="success" label="Spinning" className="text-center"></b-spinner>
                </div>
                <div class="avatar-sm ms-auto mt-1">
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle vivacious-color">
                    <span class="avatar-icon">
                      <i class="mdi mdi-file-document-multiple-outline font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-1300">
                <div class="me-3">
                  <p class="text-muted mb-2">Propositions acceptés</p>
                  <h5 class="mb-0" v-if="!LoadingStatistiques">{{ listStatistique.accepted }}</h5>
                  <b-spinner v-else variant="success" label="Spinning" className="text-center"></b-spinner>
                </div>
                <div class="avatar-sm ms-auto mt-1">
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle lochmara-color">
                    <span class="avatar-icon">
                      <i class="mdi mdi-file-check-outline font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-1300">
                <div class="me-3">
                  <p class="text-muted mb-2">Propositions en attentes</p>
                  <h5 class="mb-0" v-if="!LoadingStatistiques">{{ listStatistique.send }}</h5>
                  <b-spinner v-else variant="success" label="Spinning" className="text-center"></b-spinner>
                </div>
                <div class="avatar-sm ms-auto">
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle monarch-orange-color">
                    <span class="avatar-icon">
                      <i class="mdi mdi-file-clock-outline font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-1300">
                <div class="me-3">
                  <p class="text-muted mb-2">Propositions réfusées</p>
                  <h5 class="mb-0" v-if="!LoadingStatistiques">{{ listStatistique.refused }}</h5>
                  <b-spinner v-else variant="success" label="Spinning" className="text-center"></b-spinner>
                </div>
                <div class="avatar-sm ms-auto">
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle lovely-little-rosy-color">
                    <span class="avatar-icon">
                      <i class="mdi mdi-file-remove-outline font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4 mt-2">Les derniers dossiers</h4>
            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Dossier</th>
                    <th>Date</th>
                    <th>Montant</th>
                    <th>Voir détails</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="folder in list" :key="folder.id">
                    <td v-if="folder.s_type_bien && folder.s_usage_bien">
                      {{ demandTypeStatus(folder.s_type_bien) + ' ' + useStatus(folder.s_usage_bien) | truncate(23, "...") }}
                    </td>
                    <td v-else class="text-muted-color">Aucune données</td>
                    <td>{{ formatDate(folder.createdAt) }}</td>
                    <td v-if="folder.s_montant_global">
                      {{ folder.s_montant_global | truncateMontant() }}
                    </td>
                    <td v-else class="text-muted-color">Aucune données</td>
                    <td class="m-2">
                      <b-button pill variant="primary" size="sm" @click="redirection(folder.id)"> Voir détails
                      </b-button>
                    </td>
                  </tr>
                  <div v-if="Loading" class="mt-2 mb-2">
                    <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                  </div>
                </tbody>
              </table>
              <div v-if="!Loading && list.length === 0" class="mt-4 ">
                <b-alert show variant="danger">
                  <i class="mdi mdi-block-helper me-2"></i>Vous n’avez <strong>aucun</strong> dossier
                </b-alert>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <h4 class="card-title mb-4 mt-2">Mes dossiers favoris</h4>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Dossier</th>
                    <th>Date</th>
                    <th>Montant</th>
                    <th>Voir détails</th>
                  </tr>
                </thead>
                <tbody v-show="favorites">
                  <tr v-for="folder in favorites" :key="folder.id">
                    <td v-if="folder.s_type_bien && folder.s_usage_bien">
                      {{ demandTypeStatus(folder.s_type_bien) + ' ' + useStatus(folder.s_usage_bien) | truncate(24, " ...")
                      }}
                    </td>
                    <td v-else class="text-muted-color">Aucune données</td>
                    <td>{{ formatDate(folder.createdAt) }}</td>
                    <td v-if="folder.s_montant_global">
                      {{ folder.s_montant_global | truncateMontant() }}
                    </td>
                    <td v-else class="text-muted-color">Aucune données</td>
                    <td class="m-2">
                      <b-button pill variant="primary" size="sm" @click="redirection(folder.id)"> Voir détails
                      </b-button>
                    </td>
                  </tr>
                  <div v-if="LoadingFavorites" class="mt-2 mb-2">
                    <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                  </div>
                </tbody>
              </table>
              <div v-if="!LoadingFavorites && favorites.length === 0" class="mt-4">
                <b-alert show variant="danger">
                  <i class="mdi mdi-block-helper me-2"></i>Vous n’avez <strong>aucun</strong> dossier favoris
                </b-alert>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Mes propositions en cours</h4>
            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Dossier</th>
                    <th>Date</th>
                    <th>Etat</th>
                    <th>Voir détails</th>
                  </tr>
                </thead>
                <tbody v-if="proposals">
                  <tr v-for="propos in proposals" :key="propos.id">
                    <template v-if="propos.validUntil > new Date().toLocaleDateString('en-CA')">
                    <td v-if="propos.hasOwnProperty('req') && propos.req.s_usage_bien && propos.req.s_type_bien"
                      class="title-width">
                      {{ demandTypeStatus(propos.req.s_type_bien) + ' ' + useStatus(propos.req.s_usage_bien) | truncate(24,
                        " ...") }}
                    </td>
                    <td v-else-if="LoadingTitle">
                      <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                    </td>
                    <td v-else class="text-muted-color ">Aucune données</td>
                    <td v-if="propos.createdAt">{{ formatDate(propos.createdAt) }}</td>
                    <td>
                      <span v-if="!propos.drafts" class="badge bg-success  font-size-11 ">Envoyée</span>
                      <span v-else class="badge bg-light font-size-11 ">Brouillon</span>
                    </td>
                    <td class="m-2">
                      <b-button pill variant="primary" size="sm" @click="redirectionPropsition(propos.id)"> Voir détails </b-button>
                    </td>
                  </template>
                  </tr>
                  <div v-if="LoadingProposals" class="mt-2 mb-2">
                    <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                  </div>
                </tbody>
              </table>
              <div v-if="proposals.length === 0 && !LoadingProposals" class="mt-4 ">
                <b-alert show variant="danger">
                  <i class="mdi mdi-block-helper me-2"></i>Vous n’avez <strong>aucune </strong> proposition
                </b-alert>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { dataState } from "@/router/views/proposals/statusData";
import { proposals } from "../../../../api/entryPoint";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "ACCUEIL",
      items: [
        {
          text: "Bienvenue sur le tableau de bord",
          href: "/",
        },
        {
          text: "",
          active: true,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      dataState: [],
    };
  },
  mounted() {
    this.$store.dispatch("dashboard/listStatistique");
    this.$store.dispatch("dashboard/listProposals");
    this.$store.dispatch("dashboard/listDernierDossier");
    this.$store.dispatch("dashboard/folderFavorites");
  },
  created() {
    this.dataState = dataState;
  },
  computed: {
    listStatistique() {
      return this.$store.getters["dashboard/getAllQuotes"];
    },
    proposals() {
      return this.$store.getters["dashboard/getListProposals"];
    },
    list() {
      return this.$store.getters["dashboard/getList"];
    },
    favorites() {
      return this.$store.getters["dashboard/getFavorites"];
    },
    Loading() {
      return this.$store.getters["dashboard/getIsLoading"];
    },
    LoadingFavorites() {
      return this.$store.getters["dashboard/getIsLoadingFavorites"];
    },
    LoadingProposals() {
      return this.$store.getters["dashboard/getIsLoadingProposals"];
    },
    LoadingTitle() {
      return this.$store.getters["dashboard/getIsLoadingTitle"];
    },
    LoadingStatistiques() {
      return this.$store.getters["dashboard/getIsLoadingStatistiques"];
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
    truncateMontant: function (text) {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(text)
    },
  },
  methods: {
    redirection(root) {
      this.$root.$router.push({
        path: '/folders/' + root,
        query: { name: 'dashboard' }
      })
    },
    redirectionPropsition(root) {
      this.$root.$router.push({
        path: '/proposals/' + root,
        query: { name: 'dashboard' }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1000px) {
  .col-lg-2 {
    width: 20% !important;
  }
}

.card-body {
  background: #FFFFFF 0 0 no-repeat padding-box;
  box-shadow: 0 10px 20px #12263F08;
  border-radius: 3px;
}

.color {
  border: 1px solid #A23662;
  border-radius: 30px;
  text-align: center;
  background-color: transparent !important;
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
  color: #A23662 !important;
}

.text-muted {
  height: 35px !important;
}

.flex-1300 {
  @media screen and (max-width: 1300px) and (min-width: 900px) {
    flex-wrap: wrap !important;
  }
}
</style>